export const SITE_URL = "https://rainboyfineart.com";
export const SITE_NAME = "Rain Boy Fine Art";
export const SITE_DESCRIPTION = "Contemporary fine art gallery in Tulsa, OK featuring original work from emerging and established artists.";

// Source asset (original ~6.69 MB iPhone JPEG). Never reference directly —
// always go through the cloudinaryHero() helper so we get format/quality
// auto-negotiation and the right width for the viewport.
export const HERO_IMAGE_SOURCE = "https://customer-assets.emergentagent.com/job_ffc8d3b8-f252-461d-b818-6d0d3720c5ae/artifacts/0q6h4nvf_IMG_2603.JPG";

// Cloudinary fetch endpoint serves the original via their CDN with
// f_auto (AVIF→WebP→JPEG by browser support) and q_auto (perceptually
// lossless compression). 2400px desktop variant drops 6.69 MB → ~600 KB.
const CLOUDINARY_FETCH_BASE = "https://res.cloudinary.com/dqm8zucgy/image/fetch";

export function cloudinaryHero(width = 2400) {
  const transforms = `f_auto,q_auto,w_${width}`;
  return `${CLOUDINARY_FETCH_BASE}/${transforms}/${encodeURIComponent(HERO_IMAGE_SOURCE)}`;
}

// 2400px variant — used for the OG/Twitter image and as the default
// desktop hero. Social scrapers tend to ignore srcset, so they get the
// full-resolution optimized version.
export const HERO_IMAGE_URL = cloudinaryHero(2400);

export const GALLERY_INFO = {
  streetAddress: "3306 Charles Page Blvd #218",
  city: "Tulsa",
  state: "OK",
  zip: "74127",
  country: "US",
  phone: "(405) 885-9010",
  email: "info@rainboyfineart.com",
  socials: [
    "https://www.facebook.com/profile.php?id=61581586250780",
    "https://www.instagram.com/rainboyfineart",
    "https://www.threads.com/@rainboyfineart",
    "https://www.tiktok.com/@rainboyfineart",
  ],
  hours: [
    { days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], opens: "11:00", closes: "18:00" },
  ],
};

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  description: SITE_DESCRIPTION,
  address: {
    "@type": "PostalAddress",
    streetAddress: GALLERY_INFO.streetAddress,
    addressLocality: GALLERY_INFO.city,
    addressRegion: GALLERY_INFO.state,
    postalCode: GALLERY_INFO.zip,
    addressCountry: GALLERY_INFO.country,
  },
  telephone: GALLERY_INFO.phone,
  email: GALLERY_INFO.email,
  sameAs: GALLERY_INFO.socials,
};
